import styled from 'styled-components';
import theme from 'theme/theme';

const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 5px 45px 5px 45px;
  min-height: 65px;
  @media (max-width: ${theme.breakpoints.desktopLarge}) {
    padding: 20px 20px 33px 20px;
    min-height: 0;
  }
  
  @media print {
    padding: 20px 0;
    min-height: 0;
  }
`;

export default Header;
